<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="KeHuList" data-title="附件">
      <el-upload
        :show-file-list="false"
        :auto-upload="false"
        multiple
        :on-change="onFileChange"
      >
        <el-button
          type="primary"
          icon="Upload"
          @click="
            delete state.selectId;
            state.showInfo = true;
          "
          class="!text-xs"
          style="border-radius: 8px"
        >
          上传
        </el-button>
      </el-upload>
    </div>
    <div
      class="content c-table-box mt-2 bg-white p-2.5 rounded-lg"
      v-if="state.list_data?.length > 0"
    >
      <div class="overflow-y-auto flex flex-col gap-y-3 mt-3">
        <div
          class="bg-white p-4 flex gap-y-2 border-gray-100"
          :class="index != 0 ? 'border-t' : ''"
          v-for="(item, index) in state.list_data"
          :key="item"
        >
          <div class="flex-1">
            <ul class="flex mb-1">
              <strong class="text-lg">{{ item.name }}</strong>
              <el-button
                type="primary"
                plain
                link
                @click="onDownLoad(item)"
                class="ml-10"
              >
                <template #icon>
                  <el-icon :size="16" class="font-bold">
                    <Download />
                  </el-icon>
                </template>
              </el-button>
              <el-button type="danger" plain link @click="onDelete(item)">
                <template #icon>
                  <el-icon :size="16" class="font-bold">
                    <Delete />
                  </el-icon>
                </template>
              </el-button>
            </ul>
            <div class="flex items-center text-gray-400 text-xs gap-x-2 mt-2">
              <text class="text-sm text-gray-600">
                {{ item?.add_admin_name }}
              </text>
              <text>{{ item?.add_department_name }}</text>
              <text class="ml-1">{{ item?.create_time }} 创建</text>
            </div>
          </div>
          <el-image
            v-if="$base.Image_Exts?.includes(item.attachment?.file_ext)"
            :src="item.attachment?.file_url"
            class="w-28 h-16 rounded-md"
            :preview-src-list="[item.attachment?.file_url]"
            preview-teleported
          />
        </div>
      </div>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
    <div class="text-center" v-else>
      <el-image :src="require('@/assets/images/nodata.png')" />
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import {
  hotel_attachment_page,
  hotel_attachment_add,
  hotel_attachment_delete,
} from "@/http/hotel";
import { onDeleteConfirm } from "@/utils/funcs";
import { post_response } from "@/utils/funcs";
import { attachment_upload } from "@/http/attachment";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    hotel_id: Number,
  },
  setup(props) {
    const state = reactive({ ...new InitFormData() });
    onMounted(() => {
      state.params.hotel_id = props.hotel_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      hotel_attachment_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    const onFileChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          const { data } = res.data;
          hotel_attachment_add({
            hotel_id: props.hotel_id,
            name: data[0].origin_filename,
            attachment_id: data[0].id,
          }).then((res) => {
            post_response(res, () => {
              onLoad();
            });
          });
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(hotel_attachment_delete, row.id, onLoad, {
        filed: "酒店附件",
        name: row.name,
      });
    };

    const onDownLoad = (row) => {
      window.open(row.attachment?.file_url);
    };

    return { state, props, onLoad, onFileChange, onDelete, onDownLoad };
  },
};
</script>

<style lang="less" scoped></style>
